import { render, staticRenderFns } from "./AddPhotography.vue?vue&type=template&id=5fd73b7b&scoped=true"
import script from "./AddPhotography.vue?vue&type=script&lang=js"
export * from "./AddPhotography.vue?vue&type=script&lang=js"
import style0 from "./AddPhotography.vue?vue&type=style&index=0&id=5fd73b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd73b7b",
  null
  
)

export default component.exports